@if (settings != null) {
<form class="nm-settings" name="newMatchSettingsForm" [formGroup]="newMatchSettingsForm">

    <div class="nm-settings-section">

        <div class="nm-settings-section-title">
            {{ 'NM.TITLES.HOW_OFTEN_TO_RECEIVE' | translate }}?
        </div>

        <div class="nm-settings-section-btn-list">

            @for (option of notificationFrequencyOptions; track $index) {
            <rpc-button class="nm-settings-section-btn" [text]="option.titleTranslationKey"
                [appearanceType]="getEmailNotificationFrequencyButtonAppearance(option.frequency)"
                [color]="getEmailNotificationFrequencyButtonColor(option.frequency)"
                (clicked)="toggleEmailNotificationFrequency(option.frequency)">
            </rpc-button>
            }

        </div>

    </div>

    <div class="rpc-divider rpc-divider--horizontal">
    </div>

    @if (isEmailNotificationFrequencySelected('realtime')) {
    <div class="nm-settings-section">

        <div class="nm-settings-section-title">
            {{'NM.TITLES.DELIVERY_SCHEDULE' | translate}}
        </div>

        <div class="nm-settings-section-text">
            {{ 'NM.TEXT.REALTIME' | translate }}
        </div>

    </div>
    }

    @if (isEmailNotificationFrequencySelected('daily')) {
    <div class="nm-settings-section">

        <div class="nm-settings-section-title">
            {{'NM.TITLES.DELIVERY_SCHEDULE' | translate}}
        </div>

        <div class="nm-settings-section-bnt-wrap">

            <div class="nm-settings-section-btn-list">

                @for (option of weekDayOptions; track $index) {
                <rpc-button class="nm-settings-section-btn" [text]="option.titleTranslationKey"
                    [appearanceType]="getDailyFrequencyButtonAppearance(option.day)"
                    [color]="getDailyFrequencyButtonColor(option.day)" (clicked)="toggleDailyFrequencyDay(option.day)">
                </rpc-button>
                }

            </div>

            @if (newMatchSettingsForm.controls?.selectedDays?.value.length === 0) {
            <div class="nm-settings-section-btn-error">
                {{ 'NM.ERROR_MESSAGE.SELECT_ONE_DAY' | translate }}
            </div>
            }

        </div>

        <div class="nm-settings-section-text nm-settings-section-text--daily">
            <span class="nm-settings-section-text-first">
                {{ 'NM.TEXT.EMAILS_ARE_SENT' | translate }}
            </span>

            <rpc-select class="nm-settings-section-select nm-settings-section-select--sm" [color]="'accent'"
                [appearance]="'fill'" [controlOptions]="frequencyPerDay">
            </rpc-select>
            {{ 'NM.TEXT.PER_DAY' | translate }}
        </div>

    </div>
    }

    @if (isEmailNotificationFrequencySelected('weekly')) {
    <div class="nm-settings-section">

        <div class="nm-settings-section-title">
            {{'NM.TITLES.DELIVERY_SCHEDULE' | translate}}
        </div>

        <div class="nm-settings-section-text nm-settings-section-text--weekly">

            <span class="nm-settings-section-text-first">
                {{ 'NM.TEXT.EVERY' | translate }}
                <rpc-select class="nm-settings-section-select nm-settings-section-select--xs" [color]="'accent'"
                    [appearance]="'fill'" [controlOptions]="weeklyFrequency">
                </rpc-select>
                {{ 'NM.TEXT.WEEKS' | translate }}
            </span>

            <rpc-select class="nm-settings-section-select nm-settings-section-select--sm" [color]="'accent'"
                [appearance]="'fill'" [controlOptions]="weeklyFrequencyDay">
            </rpc-select>

        </div>

        <div class="nm-settings-section-text">
            {{ 'NM.TEXT.WEEKLY_EMAIL_SENDING' | translate }}
        </div>

    </div>
    }

    @if (isEmailNotificationFrequencySelected('monthly')) {
    <div class="nm-settings-section">

        <div class="nm-settings-section-title">
            {{'NM.TITLES.DELIVERY_SCHEDULE' | translate}}
        </div>

        <div class="nm-settings-section-text nm-settings-section-text--monthly">
            {{ 'NM.TEXT.EVERY' | translate }}
            <rpc-select class="nm-settings-section-select" [color]="'accent'" [appearance]="'fill'"
                [controlOptions]="monthlyFrequency">
            </rpc-select>
            {{ 'NM.TEXT.OF_THE_MONTH' | translate }}
        </div>

        <div class="nm-settings-section-text">
            {{ 'NM.TEXT.MONTHLY_EMAIL_SENDING' | translate }}
        </div>

    </div>
    }

</form>
}